export default {
    topics: [
        {
            title: ' InvalidAggregates ',
            href: 'sm-olapMeasure-InvalidAggregates.html',
            attributes: { 'data-id': 'sm-olapMeasure-InvalidAggregates' },
            menu: { hasChildren: false },
            tocID: 'sm-olapMeasure-InvalidAggregates-d66e1020',
            topics: [],
        },
    ],
};

